/**
 * mk-wxopen-api
 * 微信开放平台api服务
 *
 * OpenAPI spec version: last
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import ajax, { AjaxPromise, ExtraFetchParams } from '@ajax';
import * as models from '../model/models';

/* tslint:disable:no-unused-variable member-ordering object-literal-shorthand */

/**
  * @description activeMiniAuthInformationGet参数
  * @property `companyId` companyId,公司账户，必填
  * @property `[miniType]` miniType,小程序类型:miniCard名片小程序，miniMall商城小程序 miniActive活动小程序
  */
export interface ParamsactiveMiniAuthInformationGet {
  // queryParams
  /**
   * companyId,公司账户，必填
   */
  companyId: string;
  /**
   * miniType,小程序类型:miniCard名片小程序，miniMall商城小程序 miniActive活动小程序
   */
  miniType?: string;
}
/**
  * @description activeMiniAuthPageGet参数
  * @property `dustessUrl` dustessUrl,前端最终回调页面地址，必填
  * @property `companyId` companyId,公司账户，必填
  * @property `miniType` miniType,小程序类型，必填
  * @property `[appId]` 第三方平台的appId，非必填
  */
export interface ParamsactiveMiniAuthPageGet {
  // queryParams
  /**
   * dustessUrl,前端最终回调页面地址，必填
   */
  dustessUrl: string;
  /**
   * companyId,公司账户，必填
   */
  companyId: string;
  /**
   * miniType,小程序类型，必填
   */
  miniType: string;
  /**
   * 第三方平台的appId，非必填
   */
  appId?: string;
}
/**
  * @description activeMiniAuthPageRealGet参数
  * @property `token` token,授权token信息，必填
  * @property `accountid` accountid,公司账户，必填
  */
export interface ParamsactiveMiniAuthPageRealGet {
  // queryParams
  /**
   * token,授权token信息，必填
   */
  token: string;
  /**
   * accountid,公司账户，必填
   */
  accountid: string;
}
/**
  * @description activeMiniAuthReauthGet参数
  * @property `dustessUrl` dustessUrl,前端最终回调页面地址，必填
  * @property `companyId` companyId,公司账户，必填
  * @property `miniType` miniType,小程序类型，必填
  * @property `[appId]` 第三方平台的appId，非必填
  */
export interface ParamsactiveMiniAuthReauthGet {
  // queryParams
  /**
   * dustessUrl,前端最终回调页面地址，必填
   */
  dustessUrl: string;
  /**
   * companyId,公司账户，必填
   */
  companyId: string;
  /**
   * miniType,小程序类型，必填
   */
  miniType: string;
  /**
   * 第三方平台的appId，非必填
   */
  appId?: string;
}
/**
  * @description activeMiniAuthReauthRealGet参数
  * @property `dustessUrl` dustessUrl,前端最终回调页面地址，必填
  * @property `companyId` companyId,公司账户，必填
  * @property `miniType` miniType,小程序类型，必填
  * @property `[appId]` 第三方平台的appId，非必填
  */
export interface ParamsactiveMiniAuthReauthRealGet {
  // queryParams
  /**
   * dustessUrl,前端最终回调页面地址，必填
   */
  dustessUrl: string;
  /**
   * companyId,公司账户，必填
   */
  companyId: string;
  /**
   * miniType,小程序类型，必填
   */
  miniType: string;
  /**
   * 第三方平台的appId，非必填
   */
  appId?: string;
}
/**
  * @description authPageGet参数
  * @property `dustessUrl` dustessUrl,前端最终回调页面地址，必填
  * @property `companyId` companyId,公司账户，必填
  * @property `[appId]` 第三方平台的appId，非必填
  */
export interface ParamsauthPageGet {
  // queryParams
  /**
   * dustessUrl,前端最终回调页面地址，必填
   */
  dustessUrl: string;
  /**
   * companyId,公司账户，必填
   */
  companyId: string;
  /**
   * 第三方平台的appId，非必填
   */
  appId?: string;
}
/**
  * @description mallMiniAuthInformationGet参数
  * @property `companyId` companyId,公司账户，必填
  * @property `[miniType]` miniType,小程序类型:miniCard名片小程序，miniMall商城小程序 miniActive活动小程序
  */
export interface ParamsmallMiniAuthInformationGet {
  // queryParams
  /**
   * companyId,公司账户，必填
   */
  companyId: string;
  /**
   * miniType,小程序类型:miniCard名片小程序，miniMall商城小程序 miniActive活动小程序
   */
  miniType?: string;
}
/**
  * @description mallMiniAuthPageGet参数
  * @property `dustessUrl` dustessUrl,前端最终回调页面地址，必填
  * @property `companyId` companyId,公司账户，必填
  * @property `[appId]` 第三方平台的appId，非必填
  */
export interface ParamsmallMiniAuthPageGet {
  // queryParams
  /**
   * dustessUrl,前端最终回调页面地址，必填
   */
  dustessUrl: string;
  /**
   * companyId,公司账户，必填
   */
  companyId: string;
  /**
   * 第三方平台的appId，非必填
   */
  appId?: string;
}
/**
  * @description mallMiniAuthPageRealGet参数
  * @property `dustessUrl` dustessUrl,前端最终回调页面地址，必填
  * @property `companyId` companyId,公司账户，必填
  * @property `[appId]` 第三方平台的appId，非必填
  */
export interface ParamsmallMiniAuthPageRealGet {
  // queryParams
  /**
   * dustessUrl,前端最终回调页面地址，必填
   */
  dustessUrl: string;
  /**
   * companyId,公司账户，必填
   */
  companyId: string;
  /**
   * 第三方平台的appId，非必填
   */
  appId?: string;
}
/**
  * @description mallMiniAuthReauthGet参数
  * @property `dustessUrl` dustessUrl,前端最终回调页面地址，必填
  * @property `companyId` companyId,公司账户，必填
  * @property `[appId]` 第三方平台的appId，非必填
  */
export interface ParamsmallMiniAuthReauthGet {
  // queryParams
  /**
   * dustessUrl,前端最终回调页面地址，必填
   */
  dustessUrl: string;
  /**
   * companyId,公司账户，必填
   */
  companyId: string;
  /**
   * 第三方平台的appId，非必填
   */
  appId?: string;
}
/**
  * @description mallMiniAuthReauthRealGet参数
  * @property `dustessUrl` dustessUrl,前端最终回调页面地址，必填
  * @property `companyId` companyId,公司账户，必填
  * @property `[appId]` 第三方平台的appId，非必填
  */
export interface ParamsmallMiniAuthReauthRealGet {
  // queryParams
  /**
   * dustessUrl,前端最终回调页面地址，必填
   */
  dustessUrl: string;
  /**
   * companyId,公司账户，必填
   */
  companyId: string;
  /**
   * 第三方平台的appId，非必填
   */
  appId?: string;
}
/**
  * @description miniAuthApprovedStatusGet参数
  * @property `companyID` companyId,公司账户，必填
  * @property `[miniType]` miniType,小程序类型:miniCard名片小程序，miniMall商城小程序 miniActive活动小程序
  */
export interface ParamsminiAuthApprovedStatusGet {
  // queryParams
  /**
   * companyId,公司账户，必填
   */
  companyID: string;
  /**
   * miniType,小程序类型:miniCard名片小程序，miniMall商城小程序 miniActive活动小程序
   */
  miniType?: string;
}
/**
  */
export type ParamsBodyminiAuthDecryptPost = models.MiniAuthDecryptBody;
/**
  * @description miniAuthInformationGet参数
  * @property `companyId` companyId,公司账户，必填
  * @property `[miniType]` miniType,小程序类型:miniCard名片小程序，miniMall商城小程序 miniActive活动小程序
  */
export interface ParamsminiAuthInformationGet {
  // queryParams
  /**
   * companyId,公司账户，必填
   */
  companyId: string;
  /**
   * miniType,小程序类型:miniCard名片小程序，miniMall商城小程序 miniActive活动小程序
   */
  miniType?: string;
}
/**
  * @description miniAuthInformationInfoVersionGet参数
  * @property `companyId` companyId,公司账户，必填
  * @property `[miniType]` miniType,小程序类型:miniCard名片小程序，miniMall商城小程序 miniActive活动小程序
  */
export interface ParamsminiAuthInformationInfoVersionGet {
  // queryParams
  /**
   * companyId,公司账户，必填
   */
  companyId: string;
  /**
   * miniType,小程序类型:miniCard名片小程序，miniMall商城小程序 miniActive活动小程序
   */
  miniType?: string;
}
/**
  * @description miniAuthInformationVersionGet参数
  * @property `companyId` companyId,公司账户，必填
  * @property `[miniType]` miniType,小程序类型:miniCard名片小程序，miniMall商城小程序 miniActive活动小程序
  */
export interface ParamsminiAuthInformationVersionGet {
  // queryParams
  /**
   * companyId,公司账户，必填
   */
  companyId: string;
  /**
   * miniType,小程序类型:miniCard名片小程序，miniMall商城小程序 miniActive活动小程序
   */
  miniType?: string;
}
/**
  * @description miniAuthIsApprovedGet参数
  * @property `companyId` companyId,公司账户，必填
  * @property `[miniType]` miniType,小程序类型:miniCard名片小程序，miniMall商城小程序 miniActive活动小程序
  */
export interface ParamsminiAuthIsApprovedGet {
  // queryParams
  /**
   * companyId,公司账户，必填
   */
  companyId: string;
  /**
   * miniType,小程序类型:miniCard名片小程序，miniMall商城小程序 miniActive活动小程序
   */
  miniType?: string;
}
/**
  * @description miniAuthIsBindGet参数
  * @property `companyId` companyId,公司账户，必填
  * @property `[miniType]` miniType,小程序类型:miniCard名片小程序，miniMall商城小程序 miniActive活动小程序
  */
export interface ParamsminiAuthIsBindGet {
  // queryParams
  /**
   * companyId,公司账户，必填
   */
  companyId: string;
  /**
   * miniType,小程序类型:miniCard名片小程序，miniMall商城小程序 miniActive活动小程序
   */
  miniType?: string;
}
/**
  * @description miniAuthIsPermissionEnoughGet参数
  * @property `companyId` companyId,公司账户，必填
  */
export interface ParamsminiAuthIsPermissionEnoughGet {
  // queryParams
  /**
   * companyId,公司账户，必填
   */
  companyId: string;
}
/**
  */
export type ParamsBodyminiAuthLoginPost = models.MiniAuthLoginBody;
/**
  * @description miniAuthOldNameGet参数
  * @property `companyId` companyId,公司账户，必填
  * @property `[miniType]` miniType,小程序类型:miniCard名片小程序，miniMall商城小程序 miniActive活动小程序
  */
export interface ParamsminiAuthOldNameGet {
  // queryParams
  /**
   * companyId,公司账户，必填
   */
  companyId: string;
  /**
   * miniType,小程序类型:miniCard名片小程序，miniMall商城小程序 miniActive活动小程序
   */
  miniType?: string;
}
/**
  */
export type ParamsBodyminiAuthOldsystemWxDecryptPost = models.MiniAuthOldsystemWxDecryptBody;
/**
  * @description miniAuthPageGet参数
  * @property `dustessUrl` dustessUrl,前端最终回调页面地址，必填
  * @property `companyId` companyId,公司账户，必填
  * @property `[appId]` 第三方平台的appId，非必填
  * @property `[needAudit]` 第三方平台的appId，非必填
  */
export interface ParamsminiAuthPageGet {
  // queryParams
  /**
   * dustessUrl,前端最终回调页面地址，必填
   */
  dustessUrl: string;
  /**
   * companyId,公司账户，必填
   */
  companyId: string;
  /**
   * 第三方平台的appId，非必填
   */
  appId?: string;
  /**
   * 第三方平台的appId，非必填
   */
  needAudit?: string;
}
/**
  * @description miniAuthPageRealGet参数
  * @property `token` token
  */
export interface ParamsminiAuthPageRealGet {
  // queryParams
  /**
   * token
   */
  token: string;
}
/**
  * @description miniAuthReauthGet参数
  * @property `dustessUrl` dustessUrl,前端最终回调页面地址，必填
  * @property `companyId` companyId,公司账户，必填
  * @property `[appId]` 第三方平台的appId，非必填
  */
export interface ParamsminiAuthReauthGet {
  // queryParams
  /**
   * dustessUrl,前端最终回调页面地址，必填
   */
  dustessUrl: string;
  /**
   * companyId,公司账户，必填
   */
  companyId: string;
  /**
   * 第三方平台的appId，非必填
   */
  appId?: string;
}
/**
  * @description miniAuthReauthRealGet参数
  * @property `dustessUrl` dustessUrl,前端最终回调页面地址，必填
  * @property `companyId` companyId,公司账户，必填
  * @property `[appId]` 第三方平台的appId，非必填
  */
export interface ParamsminiAuthReauthRealGet {
  // queryParams
  /**
   * dustessUrl,前端最终回调页面地址，必填
   */
  dustessUrl: string;
  /**
   * companyId,公司账户，必填
   */
  companyId: string;
  /**
   * 第三方平台的appId，非必填
   */
  appId?: string;
}
/**
  * @description miniAuthResubmitPost参数
  * @property `companyId` companyId,公司账户，必填
  * @property `[miniType]` miniType,小程序类型:miniCard名片小程序，miniMall商城小程序 miniActive活动小程序
  */
export interface ParamsminiAuthResubmitPost {
  // queryParams
  /**
   * companyId,公司账户，必填
   */
  companyId: string;
  /**
   * miniType,小程序类型:miniCard名片小程序，miniMall商城小程序 miniActive活动小程序
   */
  miniType?: string;
}
/**
  */
export type ParamsBodyminiAuthWxDecryptPost = models.MiniAuthWxDecryptBody;
/**
  */
export type ParamsBodyminiAuthWxLoginPost = models.MiniAuthWxLoginBody;
/**
  * @description miniGetMallAuthAndAuditStatusGet参数
  * @property `companyId` companyId,公司账户，必填
  */
export interface ParamsminiGetMallAuthAndAuditStatusGet {
  // queryParams
  /**
   * companyId,公司账户，必填
   */
  companyId: string;
}

export class ThirdPlatformMiniAuthApi {
  protected $basePath = '/wxopen/v1'.replace(/\/$/, '');

  public constructor(basePath?: string) {
    if (basePath !== undefined) {
      this.$basePath = basePath.replace(/\/$/, '');
    }
  }

  /**
   * 
   * @summary 活动小程序信息(包括审核信息等)
   * @param params ParamsactiveMiniAuthInformationGet
   
   * @param opt ajax config
   * @returns models.MallMiniAuthInformation
   */
  public activeMiniAuthInformationGet = (
    params: ParamsactiveMiniAuthInformationGet,
    opt?: ExtraFetchParams
  ) : AjaxPromise<models.MallMiniAuthInformation>  => {
    const path = '/active_mini/auth/information';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('companyId' in params) p.query.companyId = params.companyId;
    ajax.check(params.companyId, 'companyId');
    if ('miniType' in params) p.query.miniType = params.miniType;
    return ajax.ajax({
      ...opt,
      method: 'GET',
      url,
      ...p
    });
  }
  /**
   * 
   * @summary 微信 第三方平台授权-返回认证页面
   * @param params ParamsactiveMiniAuthPageGet
   
   * @param opt ajax config
   * @returns models.MiniGetUnlimitWxacode
   */
  public activeMiniAuthPageGet = (
    params: ParamsactiveMiniAuthPageGet,
    opt?: ExtraFetchParams
  ) : AjaxPromise<models.MiniGetUnlimitWxacode>  => {
    const path = '/active_mini/auth/page';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('dustessUrl' in params) p.query.dustessUrl = params.dustessUrl;
    ajax.check(params.dustessUrl, 'dustessUrl');
    if ('companyId' in params) p.query.companyId = params.companyId;
    ajax.check(params.companyId, 'companyId');
    if ('miniType' in params) p.query.miniType = params.miniType;
    ajax.check(params.miniType, 'miniType');
    if ('appId' in params) p.query.appId = params.appId;
    return ajax.ajax({
      ...opt,
      method: 'GET',
      url,
      ...p
    });
  }
  /**
   * 
   * @summary 微信 活动小程序第三方平台授权-返回认证页面
   * @param params ParamsactiveMiniAuthPageRealGet
   
   * @param opt ajax config
   * @returns models.MiniGetUnlimitWxacode
   */
  public activeMiniAuthPageRealGet = (
    params: ParamsactiveMiniAuthPageRealGet,
    opt?: ExtraFetchParams
  ) : AjaxPromise<models.MiniGetUnlimitWxacode>  => {
    const path = '/active_mini/auth/page_real';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('token' in params) p.query.token = params.token;
    ajax.check(params.token, 'token');
    if ('accountid' in params) p.query.accountid = params.accountid;
    ajax.check(params.accountid, 'accountid');
    return ajax.ajax({
      ...opt,
      method: 'GET',
      url,
      ...p
    });
  }
  /**
   * 
   * @summary 活动小程序，权限集重新勾选,重新授权接口
   * @param params ParamsactiveMiniAuthReauthGet
   
   * @param opt ajax config
   * @returns models.MiniGetUnlimitWxacode
   */
  public activeMiniAuthReauthGet = (
    params: ParamsactiveMiniAuthReauthGet,
    opt?: ExtraFetchParams
  ) : AjaxPromise<models.MiniGetUnlimitWxacode>  => {
    const path = '/active_mini/auth/reauth';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('dustessUrl' in params) p.query.dustessUrl = params.dustessUrl;
    ajax.check(params.dustessUrl, 'dustessUrl');
    if ('companyId' in params) p.query.companyId = params.companyId;
    ajax.check(params.companyId, 'companyId');
    if ('miniType' in params) p.query.miniType = params.miniType;
    ajax.check(params.miniType, 'miniType');
    if ('appId' in params) p.query.appId = params.appId;
    return ajax.ajax({
      ...opt,
      method: 'GET',
      url,
      ...p
    });
  }
  /**
   * 
   * @summary 活动小程序权限集重新勾选,重新授权接口(实际逻辑)
   * @param params ParamsactiveMiniAuthReauthRealGet
   
   * @param opt ajax config
   * @returns models.MiniGetUnlimitWxacode
   */
  public activeMiniAuthReauthRealGet = (
    params: ParamsactiveMiniAuthReauthRealGet,
    opt?: ExtraFetchParams
  ) : AjaxPromise<models.MiniGetUnlimitWxacode>  => {
    const path = '/active_mini/auth/reauth_real';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('dustessUrl' in params) p.query.dustessUrl = params.dustessUrl;
    ajax.check(params.dustessUrl, 'dustessUrl');
    if ('companyId' in params) p.query.companyId = params.companyId;
    ajax.check(params.companyId, 'companyId');
    if ('miniType' in params) p.query.miniType = params.miniType;
    ajax.check(params.miniType, 'miniType');
    if ('appId' in params) p.query.appId = params.appId;
    return ajax.ajax({
      ...opt,
      method: 'GET',
      url,
      ...p
    });
  }
  /**
   * 
   * @summary 微信 第三方平台授权-返回认证页面
   * @param params ParamsauthPageGet
   
   * @param opt ajax config
   * @returns models.MiniGetUnlimitWxacode
   */
  public authPageGet = (
    params: ParamsauthPageGet,
    opt?: ExtraFetchParams
  ) : AjaxPromise<models.MiniGetUnlimitWxacode>  => {
    const path = '/auth/page';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('dustessUrl' in params) p.query.dustessUrl = params.dustessUrl;
    ajax.check(params.dustessUrl, 'dustessUrl');
    if ('companyId' in params) p.query.companyId = params.companyId;
    ajax.check(params.companyId, 'companyId');
    if ('appId' in params) p.query.appId = params.appId;
    return ajax.ajax({
      ...opt,
      method: 'GET',
      url,
      ...p
    });
  }
  /**
   * 
   * @summary 商城小程序信息(包括审核信息等)
   * @param params ParamsmallMiniAuthInformationGet
   
   * @param opt ajax config
   * @returns models.MallMiniAuthInformation
   */
  public mallMiniAuthInformationGet = (
    params: ParamsmallMiniAuthInformationGet,
    opt?: ExtraFetchParams
  ) : AjaxPromise<models.MallMiniAuthInformation>  => {
    const path = '/mall_mini/auth/information';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('companyId' in params) p.query.companyId = params.companyId;
    ajax.check(params.companyId, 'companyId');
    if ('miniType' in params) p.query.miniType = params.miniType;
    return ajax.ajax({
      ...opt,
      method: 'GET',
      url,
      ...p
    });
  }
  /**
   * 
   * @summary 微信 第三方平台授权-返回认证页面
   * @param params ParamsmallMiniAuthPageGet
   
   * @param opt ajax config
   * @returns models.MiniGetUnlimitWxacode
   */
  public mallMiniAuthPageGet = (
    params: ParamsmallMiniAuthPageGet,
    opt?: ExtraFetchParams
  ) : AjaxPromise<models.MiniGetUnlimitWxacode>  => {
    const path = '/mall_mini/auth/page';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('dustessUrl' in params) p.query.dustessUrl = params.dustessUrl;
    ajax.check(params.dustessUrl, 'dustessUrl');
    if ('companyId' in params) p.query.companyId = params.companyId;
    ajax.check(params.companyId, 'companyId');
    if ('appId' in params) p.query.appId = params.appId;
    return ajax.ajax({
      ...opt,
      method: 'GET',
      url,
      ...p
    });
  }
  /**
   * 
   * @summary 微信 第三方平台授权-返回认证页面
   * @param params ParamsmallMiniAuthPageRealGet
   
   * @param opt ajax config
   * @returns models.MiniGetUnlimitWxacode
   */
  public mallMiniAuthPageRealGet = (
    params: ParamsmallMiniAuthPageRealGet,
    opt?: ExtraFetchParams
  ) : AjaxPromise<models.MiniGetUnlimitWxacode>  => {
    const path = '/mall_mini/auth/page_real';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('dustessUrl' in params) p.query.dustessUrl = params.dustessUrl;
    ajax.check(params.dustessUrl, 'dustessUrl');
    if ('companyId' in params) p.query.companyId = params.companyId;
    ajax.check(params.companyId, 'companyId');
    if ('appId' in params) p.query.appId = params.appId;
    return ajax.ajax({
      ...opt,
      method: 'GET',
      url,
      ...p
    });
  }
  /**
   * 
   * @summary 商城版本需要,权限集重新勾选,重新授权接口
   * @param params ParamsmallMiniAuthReauthGet
   
   * @param opt ajax config
   * @returns models.MiniGetUnlimitWxacode
   */
  public mallMiniAuthReauthGet = (
    params: ParamsmallMiniAuthReauthGet,
    opt?: ExtraFetchParams
  ) : AjaxPromise<models.MiniGetUnlimitWxacode>  => {
    const path = '/mall_mini/auth/reauth';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('dustessUrl' in params) p.query.dustessUrl = params.dustessUrl;
    ajax.check(params.dustessUrl, 'dustessUrl');
    if ('companyId' in params) p.query.companyId = params.companyId;
    ajax.check(params.companyId, 'companyId');
    if ('appId' in params) p.query.appId = params.appId;
    return ajax.ajax({
      ...opt,
      method: 'GET',
      url,
      ...p
    });
  }
  /**
   * 
   * @summary 商城版本需要,权限集重新勾选,重新授权接口(实际逻辑)
   * @param params ParamsmallMiniAuthReauthRealGet
   
   * @param opt ajax config
   * @returns models.MiniGetUnlimitWxacode
   */
  public mallMiniAuthReauthRealGet = (
    params: ParamsmallMiniAuthReauthRealGet,
    opt?: ExtraFetchParams
  ) : AjaxPromise<models.MiniGetUnlimitWxacode>  => {
    const path = '/mall_mini/auth/reauth_real';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('dustessUrl' in params) p.query.dustessUrl = params.dustessUrl;
    ajax.check(params.dustessUrl, 'dustessUrl');
    if ('companyId' in params) p.query.companyId = params.companyId;
    ajax.check(params.companyId, 'companyId');
    if ('appId' in params) p.query.appId = params.appId;
    return ajax.ajax({
      ...opt,
      method: 'GET',
      url,
      ...p
    });
  }
  /**
   * 
   * @summary 审核状态
   * @param params ParamsminiAuthApprovedStatusGet
   
   * @param opt ajax config
   * @returns models.MiniAuthApprovedStatus
   */
  public miniAuthApprovedStatusGet = (
    params: ParamsminiAuthApprovedStatusGet,
    opt?: ExtraFetchParams
  ) : AjaxPromise<models.MiniAuthApprovedStatus>  => {
    const path = '/mini/auth/approved/status';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('companyID' in params) p.query.companyID = params.companyID;
    ajax.check(params.companyID, 'companyID');
    if ('miniType' in params) p.query.miniType = params.miniType;
    return ajax.ajax({
      ...opt,
      method: 'GET',
      url,
      ...p
    });
  }
  /**
   * 
   * @summary 小程序登陆解密数据获得用户信息或者手机号
   
   * @param data: ParamsBodyminiAuthDecryptPost
   * @param opt ajax config
   * @returns models.MiniAuthOldsystemWxDecrypt
   */
  public miniAuthDecryptPost = (
    
    data: ParamsBodyminiAuthDecryptPost,opt?: ExtraFetchParams
  ) : AjaxPromise<models.MiniAuthOldsystemWxDecrypt>  => {
    const path = '/mini/auth/decrypt';
    const url = this.$basePath + path;
    const p: any = {};
    p.data = data;
    return ajax.ajax({
      ...opt,
      method: 'POST',
      url,
      ...p
    });
  }
  /**
   * 
   * @summary 小程序信息(包括审核信息等)
   * @param params ParamsminiAuthInformationGet
   
   * @param opt ajax config
   * @returns models.MiniAuthInformation
   */
  public miniAuthInformationGet = (
    params: ParamsminiAuthInformationGet,
    opt?: ExtraFetchParams
  ) : AjaxPromise<models.MiniAuthInformation>  => {
    const path = '/mini/auth/information';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('companyId' in params) p.query.companyId = params.companyId;
    ajax.check(params.companyId, 'companyId');
    if ('miniType' in params) p.query.miniType = params.miniType;
    return ajax.ajax({
      ...opt,
      method: 'GET',
      url,
      ...p
    });
  }
  /**
   * 
   * @summary 小程序信息-是否是第一次审核(包括审核信息等)
   * @param params ParamsminiAuthInformationInfoVersionGet
   
   * @param opt ajax config
   * @returns models.MiniAuthInformation
   */
  public miniAuthInformationInfoVersionGet = (
    params: ParamsminiAuthInformationInfoVersionGet,
    opt?: ExtraFetchParams
  ) : AjaxPromise<models.MiniAuthInformation>  => {
    const path = '/mini/auth/information/info_version';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('companyId' in params) p.query.companyId = params.companyId;
    ajax.check(params.companyId, 'companyId');
    if ('miniType' in params) p.query.miniType = params.miniType;
    return ajax.ajax({
      ...opt,
      method: 'GET',
      url,
      ...p
    });
  }
  /**
   * 
   * @summary 小程序版本信息
   * @param params ParamsminiAuthInformationVersionGet
   
   * @param opt ajax config
   * @returns models.MiniAuthInformationVersion
   */
  public miniAuthInformationVersionGet = (
    params: ParamsminiAuthInformationVersionGet,
    opt?: ExtraFetchParams
  ) : AjaxPromise<models.MiniAuthInformationVersion>  => {
    const path = '/mini/auth/information/version';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('companyId' in params) p.query.companyId = params.companyId;
    ajax.check(params.companyId, 'companyId');
    if ('miniType' in params) p.query.miniType = params.miniType;
    return ajax.ajax({
      ...opt,
      method: 'GET',
      url,
      ...p
    });
  }
  /**
   * 
   * @summary 是否审核通过
   * @param params ParamsminiAuthIsApprovedGet
   
   * @param opt ajax config
   * @returns models.MiniAuthIsApproved
   */
  public miniAuthIsApprovedGet = (
    params: ParamsminiAuthIsApprovedGet,
    opt?: ExtraFetchParams
  ) : AjaxPromise<models.MiniAuthIsApproved>  => {
    const path = '/mini/auth/is/approved';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('companyId' in params) p.query.companyId = params.companyId;
    ajax.check(params.companyId, 'companyId');
    if ('miniType' in params) p.query.miniType = params.miniType;
    return ajax.ajax({
      ...opt,
      method: 'GET',
      url,
      ...p
    });
  }
  /**
   * 
   * @summary 小程序是否绑定
   * @param params ParamsminiAuthIsBindGet
   
   * @param opt ajax config
   * @returns models.MiniGetUnlimitWxacode
   */
  public miniAuthIsBindGet = (
    params: ParamsminiAuthIsBindGet,
    opt?: ExtraFetchParams
  ) : AjaxPromise<models.MiniGetUnlimitWxacode>  => {
    const path = '/mini/auth/is/bind';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('companyId' in params) p.query.companyId = params.companyId;
    ajax.check(params.companyId, 'companyId');
    if ('miniType' in params) p.query.miniType = params.miniType;
    return ajax.ajax({
      ...opt,
      method: 'GET',
      url,
      ...p
    });
  }
  /**
   * 
   * @summary 判断权限集是否够
   * @param params ParamsminiAuthIsPermissionEnoughGet
   
   * @param opt ajax config
   * @returns models.MiniAuthIsPermissionEnough
   */
  public miniAuthIsPermissionEnoughGet = (
    params: ParamsminiAuthIsPermissionEnoughGet,
    opt?: ExtraFetchParams
  ) : AjaxPromise<models.MiniAuthIsPermissionEnough>  => {
    const path = '/mini/auth/is/permission/enough';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('companyId' in params) p.query.companyId = params.companyId;
    ajax.check(params.companyId, 'companyId');
    return ajax.ajax({
      ...opt,
      method: 'GET',
      url,
      ...p
    });
  }
  /**
   * 
   * @summary 小程序登陆
   
   * @param data: ParamsBodyminiAuthLoginPost
   * @param opt ajax config
   * @returns models.MiniAuthLogin
   */
  public miniAuthLoginPost = (
    
    data: ParamsBodyminiAuthLoginPost,opt?: ExtraFetchParams
  ) : AjaxPromise<models.MiniAuthLogin>  => {
    const path = '/mini/auth/login';
    const url = this.$basePath + path;
    const p: any = {};
    p.data = data;
    return ajax.ajax({
      ...opt,
      method: 'POST',
      url,
      ...p
    });
  }
  /**
   * 
   * @summary 获得小程序原始名称
   * @param params ParamsminiAuthOldNameGet
   
   * @param opt ajax config
   * @returns any
   */
  public miniAuthOldNameGet = (
    params: ParamsminiAuthOldNameGet,
    opt?: ExtraFetchParams
  ) : AjaxPromise<any>  => {
    const path = '/mini/auth/old/name';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('companyId' in params) p.query.companyId = params.companyId;
    ajax.check(params.companyId, 'companyId');
    if ('miniType' in params) p.query.miniType = params.miniType;
    return ajax.ajax({
      ...opt,
      method: 'GET',
      url,
      ...p
    });
  }
  /**
   * 
   * @summary 小程序登陆解密数据获得用户信息（老系统）
   
   * @param data: ParamsBodyminiAuthOldsystemWxDecryptPost
   * @param opt ajax config
   * @returns models.MiniAuthOldsystemWxDecrypt
   */
  public miniAuthOldsystemWxDecryptPost = (
    
    data: ParamsBodyminiAuthOldsystemWxDecryptPost,opt?: ExtraFetchParams
  ) : AjaxPromise<models.MiniAuthOldsystemWxDecrypt>  => {
    const path = '/mini/auth/oldsystem_wx_decrypt';
    const url = this.$basePath + path;
    const p: any = {};
    p.data = data;
    return ajax.ajax({
      ...opt,
      method: 'POST',
      url,
      ...p
    });
  }
  /**
   * 
   * @summary 微信 第三方平台授权-返回认证页面
   * @param params ParamsminiAuthPageGet
   
   * @param opt ajax config
   * @returns models.MiniGetUnlimitWxacode
   */
  public miniAuthPageGet = (
    params: ParamsminiAuthPageGet,
    opt?: ExtraFetchParams
  ) : AjaxPromise<models.MiniGetUnlimitWxacode>  => {
    const path = '/mini/auth/page';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('dustessUrl' in params) p.query.dustessUrl = params.dustessUrl;
    ajax.check(params.dustessUrl, 'dustessUrl');
    if ('companyId' in params) p.query.companyId = params.companyId;
    ajax.check(params.companyId, 'companyId');
    if ('appId' in params) p.query.appId = params.appId;
    if ('needAudit' in params) p.query.needAudit = params.needAudit;
    return ajax.ajax({
      ...opt,
      method: 'GET',
      url,
      ...p
    });
  }
  /**
   * 
   * @summary 微信 第三方平台授权-返回认证页面
   * @param params ParamsminiAuthPageRealGet
   
   * @param opt ajax config
   * @returns models.MiniGetUnlimitWxacode
   */
  public miniAuthPageRealGet = (
    params: ParamsminiAuthPageRealGet,
    opt?: ExtraFetchParams
  ) : AjaxPromise<models.MiniGetUnlimitWxacode>  => {
    const path = '/mini/auth/page_real';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('token' in params) p.query.token = params.token;
    ajax.check(params.token, 'token');
    return ajax.ajax({
      ...opt,
      method: 'GET',
      url,
      ...p
    });
  }
  /**
   * 
   * @summary 商城版本需要,权限集重新勾选,重新授权接口
   * @param params ParamsminiAuthReauthGet
   
   * @param opt ajax config
   * @returns models.MiniGetUnlimitWxacode
   */
  public miniAuthReauthGet = (
    params: ParamsminiAuthReauthGet,
    opt?: ExtraFetchParams
  ) : AjaxPromise<models.MiniGetUnlimitWxacode>  => {
    const path = '/mini/auth/reauth';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('dustessUrl' in params) p.query.dustessUrl = params.dustessUrl;
    ajax.check(params.dustessUrl, 'dustessUrl');
    if ('companyId' in params) p.query.companyId = params.companyId;
    ajax.check(params.companyId, 'companyId');
    if ('appId' in params) p.query.appId = params.appId;
    return ajax.ajax({
      ...opt,
      method: 'GET',
      url,
      ...p
    });
  }
  /**
   * 
   * @summary 商城版本需要,权限集重新勾选,重新授权接口(实际逻辑)
   * @param params ParamsminiAuthReauthRealGet
   
   * @param opt ajax config
   * @returns models.MiniGetUnlimitWxacode
   */
  public miniAuthReauthRealGet = (
    params: ParamsminiAuthReauthRealGet,
    opt?: ExtraFetchParams
  ) : AjaxPromise<models.MiniGetUnlimitWxacode>  => {
    const path = '/mini/auth/reauth_real';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('dustessUrl' in params) p.query.dustessUrl = params.dustessUrl;
    ajax.check(params.dustessUrl, 'dustessUrl');
    if ('companyId' in params) p.query.companyId = params.companyId;
    ajax.check(params.companyId, 'companyId');
    if ('appId' in params) p.query.appId = params.appId;
    return ajax.ajax({
      ...opt,
      method: 'GET',
      url,
      ...p
    });
  }
  /**
   * 
   * @summary 小程序重新提交审核
   * @param params ParamsminiAuthResubmitPost
   
   * @param opt ajax config
   * @returns models.MiniGetUnlimitWxacode
   */
  public miniAuthResubmitPost = (
    params: ParamsminiAuthResubmitPost,
    opt?: ExtraFetchParams
  ) : AjaxPromise<models.MiniGetUnlimitWxacode>  => {
    const path = '/mini/auth/resubmit';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('companyId' in params) p.query.companyId = params.companyId;
    ajax.check(params.companyId, 'companyId');
    if ('miniType' in params) p.query.miniType = params.miniType;
    return ajax.ajax({
      ...opt,
      method: 'POST',
      url,
      ...p
    });
  }
  /**
   * 
   * @summary 小程序登陆解密数据获得用户信息
   
   * @param data: ParamsBodyminiAuthWxDecryptPost
   * @param opt ajax config
   * @returns models.MiniAuthOldsystemWxDecrypt
   */
  public miniAuthWxDecryptPost = (
    
    data: ParamsBodyminiAuthWxDecryptPost,opt?: ExtraFetchParams
  ) : AjaxPromise<models.MiniAuthOldsystemWxDecrypt>  => {
    const path = '/mini/auth/wx_decrypt';
    const url = this.$basePath + path;
    const p: any = {};
    p.data = data;
    return ajax.ajax({
      ...opt,
      method: 'POST',
      url,
      ...p
    });
  }
  /**
   * 
   * @summary 小程序登陆改
   
   * @param data: ParamsBodyminiAuthWxLoginPost
   * @param opt ajax config
   * @returns models.MiniAuthWxLogin
   */
  public miniAuthWxLoginPost = (
    
    data: ParamsBodyminiAuthWxLoginPost,opt?: ExtraFetchParams
  ) : AjaxPromise<models.MiniAuthWxLogin>  => {
    const path = '/mini/auth/wx_login';
    const url = this.$basePath + path;
    const p: any = {};
    p.data = data;
    return ajax.ajax({
      ...opt,
      method: 'POST',
      url,
      ...p
    });
  }
  /**
   * 
   * @summary 获取商城小程序授权审核转态
   * @param params ParamsminiGetMallAuthAndAuditStatusGet
   
   * @param opt ajax config
   * @returns models.MiniGetMallAuthAndAuditStatus
   */
  public miniGetMallAuthAndAuditStatusGet = (
    params: ParamsminiGetMallAuthAndAuditStatusGet,
    opt?: ExtraFetchParams
  ) : AjaxPromise<models.MiniGetMallAuthAndAuditStatus>  => {
    const path = '/mini/get_mall_auth_and_audit_status';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('companyId' in params) p.query.companyId = params.companyId;
    ajax.check(params.companyId, 'companyId');
    return ajax.ajax({
      ...opt,
      method: 'GET',
      url,
      ...p
    });
  }
}

export default new ThirdPlatformMiniAuthApi();